export const ids = [
	'transaction-created',
	'transaction-deleted',
	'transaction-duplicated',
	'transaction-reworked',
	'transaction-completed',
	'transaction-unallocated',
	'transaction-unassigned',
	'transaction-allocated',
	'transaction-reallocated',
	'ai-completed',
	'ai-feedback-changed',
	//
	'qa-person-assigned',
	'team-leader-assigned',
	'owner-assigned',
	'stage-assignee-changed',
	//
	'drawing-started',
	'drawing-status-changed',
	'drawing-ended',
	//
	'stage-started',
	'stage-status-changed',
	'stage-ended',
	//
	'details-changed',
	'difficulty-rating-updated',
	'difficulty-rating-org-updated',
	'volumetrics-total-updated',
	'volumetrics-truss-types-updated',
	//
	'stage-timer-paused',
	'stage-timer-resumed',
	//
	'file-uploaded',
	'file-downloaded',
	'file-moved',
	'file-deleted',
	'file-uploaded-to-iCommand',
	'file-version-changed',
	'file-label-set',
	'file-label-reset',
	//
	'folder-created',
	'folder-renamed',
	'folder-deleted',
	//
	'transaction-pending',
	'transaction-assigned',
	'transaction-in-progress',
	'transaction-completed',
	//
	'transaction-completed-email',
	// icommand
	'transaction-details-updated-in-icommand',
	'transaction-created-in-icommand',
	'itw-icommand-sync-enabled',
	'itw-icommand-sync-disabled',
	//
	'file-processing-completed',
	//
	'form-data-changed',
	//
	'timeline-entry-created',
	'timeline-entry-updated',
	'timeline-entry-deleted',
] as const;
